import { AfterViewInit, Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { environment } from '@env/environment';
import { LicenseManager } from 'ag-grid-enterprise';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['app.component.scss'],
})

export class AppComponent implements OnInit, AfterViewInit {

  constructor(private router: Router) {
    LicenseManager.setLicenseKey(environment.agGridLicenseKey);
  }

  ngOnInit() {

  }

  ngAfterViewInit() {
  }

}
